import { z } from 'zod';

export const experienceRowSchema = z.object({
  id: z.string().min(1),
  year: z.string(),
  title: z.string().min(1),
  description: z.string(),
  sortOrder: z.number().int(),
  visible: z.boolean(),
});

export const experienceInsertSchema = z.object({
  id: z.string().min(1).optional(),
  year: z.string(),
  title: z.string().min(1),
  description: z.string(),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const experienceUpdateSchema = experienceInsertSchema.partial();

export type ExperienceRow = z.infer<typeof experienceRowSchema>;
export type ExperienceInsert = z.input<typeof experienceInsertSchema>;
export type ExperienceUpdate = z.input<typeof experienceUpdateSchema>;
